import {Component} from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';
import {logout} from '../../actions/user-actions';

class LogoutContainer extends Component {
    componentWillMount() {
        this.props.dispatch(logout());
    }

    render() {
        return null;
    }

}

LogoutContainer.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default connect()(LogoutContainer);




// WEBPACK FOOTER //
// ./src/js/routes/logout/logout-container.js